/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CoachMarkAPI
 * @hideconstructor
 * @classdesc API class to allow assets to implement independent functionality for coachmarks
 */
define([], () => {
	class CoachMarkAPI {
		/**
		 * Add a coachmark dynamically to the UI.
		 * @public
		 * @param options -	The options parameter takes the following values to add the coachmark:
		 * 		id: the identifier for the element to attach the coachmark to,
		 * 		domElement: the element to attach the coachmark to,
		 * 		title: the title string for the coachmark,
		 * 		content: the content string for the coachmark
		 * @description shows the contents of the current asset before printing
		 */
		addCoachMark() {}
	}

	return CoachMarkAPI;
});
